module.exports = __webpack_public_path__ + "img/49.9b94722a.svg";